"use client";
import { ContentWrapper } from "../../../Wrappers/ContentWrapper";

import { CollectionItemsPagination } from "../../Collections/CollectionItemsPagination";
import { MarketplaceFilter } from "../../Marketplace/MarketplaceFilter";
import { SearchInput } from "../../Search/SearchInput";
import { ListActionsWrapper } from "../../ListActionsWrapper";
import { useState } from "react";

export default function Collections() {
  const [searchTerm, setSearchTerm] = useState("");
  const [marketplaces, setMarketplaces] = useState<string[]>([]);
  return (
    <ContentWrapper
      pageWrapper
      removePaddingOnMobile
      className="mb-10"
      fullWidth
    >
      <ListActionsWrapper twoRowsOnMobile>
        <SearchInput searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <MarketplaceFilter
          marketplaces={marketplaces}
          setMarketplaces={setMarketplaces}
        />
      </ListActionsWrapper>
      <CollectionItemsPagination
        searchTerm={searchTerm}
        marketplaces={marketplaces}
      />
    </ContentWrapper>
  );
}
